import PlainDate from '@Domain/PlainDate';

export type InterviewDatedPayload = {
	readonly conductedOn: string;
};

/**
 * `conductedOn` is a calendar date, with no time of day and no timezone — a `date` column, never an
 * ISO 8601 instant — so it is rebuilt from local calendar components through `PlainDate.fromApi`,
 * never through ISO-string parsing.
 *
 * The return type spells out `Omit<Payload, …> & {…}` instead of the `Computed` helper directly:
 * `Computed` bounds its override to `Partial<Record<keyof Payload, unknown>>`, a constraint
 * TypeScript cannot verify against a still-generic `Payload`, even though
 * `Payload extends InterviewDatedPayload` guarantees it.
 */
const computeInterviewPayload = <Payload extends InterviewDatedPayload>(
	payload: Payload,
): Omit<Payload, 'conductedOn'> & { readonly conductedOn: PlainDate | null } => ({
	...payload,
	conductedOn: PlainDate.fromApi(payload.conductedOn),
});

export default computeInterviewPayload;
